import { render, staticRenderFns } from "./CompetitionFilterUserLayout.vue?vue&type=template&id=0c867b22&scoped=true&"
import script from "./CompetitionFilterUserLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterUserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c867b22",
  null
  
)

export default component.exports